import { request } from '@max/meituan-uni-network';
import { getSystemType, SystemType, getPlatformType, PlatformType, isWeixinMiniProgramOrWeixinWebview, isDianpingAppOrWebview, isMeituanAppOrWebview, getAppVersion } from '@nibfe/mkt-env-api';
// 会报错，先不主动上报ajax相关错误
// import { reportJSInfo } from '@max/meituan-uni-report';
const isMRN = false;
const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
import { handleParams } from './common-api/utils';
const systemType = getSystemType();
/**
 * 美团APP-1 点评APP-2 微信美团小程序-3 微信美团酒店小程序-4 微信点评小程序-5 未知-999
 */
export const getSourceAndPlatform = () => {
    let source = 'group';
    // 微信小程序或微信 webview 打开
    if (isWeixinMiniProgramOrWeixinWebview()) {
        const platformType = getPlatformType();
        switch (platformType) {
            // 美小
            case PlatformType.mtMinaWebview:
                source = 'group_wxapp';
                break;
            // 酒小
            case PlatformType.mtHotelMinaWebview:
                source = 'hotel_wxapp';
                break;
            // 其它、微信 webview
            default:
                source = 'group';
                break;
        }
    }
    // 点评 APP
    else if (isDianpingAppOrWebview()) {
        source = 'dianping_nova';
    }
    // 美团 APP
    else if (isMeituanAppOrWebview()) {
        source = 'group';
    }
    const platform = getPlatformType();
    //const isMt = [PlatformType.mtApp, PlatformType.mtAppWebView,PlatformType.mtMinaWebview,PlatformType.mtHotelMinaWebview].includes(platform);
    const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView, PlatformType.dpMinaWebview].includes(platform);
    let platformNum;
    if (isDp) {
        platformNum = 2;
    }
    else {
        platformNum = 1;
    }
    return {
        platform: platformNum,
        source
    };
};
export const AJAX_ERROR_NAME = '网络错误';
const fetchData = (data, params = {}, wakeupSource, onApiSuccess, onApiFailed) => {
    // 完全和tex1.0 的poi动态列表保持一致
    const { platform, source } = getSourceAndPlatform();
    console.log('platform===source====wakeupSource', platform, source, wakeupSource);
    const defaultData = {
        client: systemType === SystemType.android ? 4 : 5,
        platform,
        source,
        appVersion: getAppVersion(),
        wakeupsource: wakeupSource || 'waitou_default'
        // childAges: '',
        // roomCount: '1',
        // numberOfAdults: '1',
        // memberGoodsPoiFirst: true,
        // numberOfChildren: '0',
        // hideNoFlagshipGoodsPoi: false,
        // filterFlagshipGoods: false,
    };
    const realData = Object.assign(Object.assign({}, defaultData), data);
    let finalData = realData;
    console.log("加反爬参数之前", finalData);
    if (true) {
        try {
            const antiReq = new AntiReqTool({
                autoFillParams: true
            });
            // @ts-ignore
            finalData = antiReq.addCommonParams(finalData);
        }
        catch (e) {
            console.warn('添加反爬参数失败', e);
            // reportJSInfo({ level: 'info', content: '请求加上反爬参数错误', secCategory: 'ajaxError' });
        }
    }
    console.log("请求前");
    return new Promise((resolve, reject) => {
        request({
            // 站外没有version，这里先直接写死一个
            url: `https://ihotel.meituan.com/landing/page/homestayDynamicShelves/queryProductInfo?` + handleParams(params),
            // url:
            // `https://api.hotel.test.meituan.com/landing/page/homestayDynamicShelves/queryProductInfo` +
            // handleParams(params),
            method: 'POST',
            data: Object.assign({}, finalData),
            header: {
                'Content-Type': 'application/json'
                // 'isPtest': true, // ptest环境测试，上线前需注释掉
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'phx',
                params
            },
            success(res) {
                var _a, _b, _c;
                console.log("请求成功===", (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data);
                onApiSuccess();
                if (((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.status) === 0) {
                    const templateRes = ((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.data) || {};
                    resolve(templateRes);
                }
                else {
                    const error = new Error(AJAX_ERROR_NAME);
                    error.name = AJAX_ERROR_NAME;
                    error.message = '请求接口异常-code非200';
                    // const tags = {
                    //   response: JSON.stringify(res),
                    //   params: JSON.stringify(finalData),
                    // };
                    // reportJSInfo({
                    //   secCategory: 'ajaxError',
                    //   level: 'info',
                    //   error,
                    //   tags,
                    // });
                    reject(error);
                }
            },
            fail(error) {
                onApiFailed();
                error.name = AJAX_ERROR_NAME;
                error.message = '请求接口异常-网络异常';
                // const tags = {
                //   test: JSON.stringify(error),
                //   params: JSON.stringify(finalData),
                // };
                // reportJSInfo({
                //   secCategory: 'ajaxError',
                //   level: 'info',
                //   error,
                //   tags,
                // });
                reject(error);
            }
        });
        // const templateRes = TestData?.data as IMoudleResponse;
        // resolve(templateRes);
    });
};
export default fetchData;
